<mat-form-field class="cv-material-control" [class.cv-auto-width]="autoWidth" appearance="fill">
    <!-- <mat-label>Select an option</mat-label> -->
    <mat-select
        [attr.id]="id"
        class="my-auto lato-regular"
        [style]="customStyle ? customStyle : {}"
        [panelClass]="showSelectAllOrNoneButtons ? 'cv-material-control overflow-hidden custom-panel-class' : 'cv-material-control overflow-hidden'"
        [value]="value"
        [disabled]="disabled || isLoading"
        (openedChange)="$event ? onOpen() : onClose()"
        [multiple]="true"
        [placeholder]="placeholder"
        [disableRipple]="true"
        [ngClass]="showSelectedToggle ? 'hasToggle' : 'hasNoToggle'"
    >
        <mat-select-trigger *ngIf="selectionText && overwritePlaceholder" [class.is-disabled]="disabled || isLoading">
            {{ selectionText }}
        </mat-select-trigger>
        <mat-select-trigger *ngIf="!overwritePlaceholder">
            {{ placeholder }}
        </mat-select-trigger>
        <div *ngIf="showSelectAllOrNoneButtons" class="p-1 select-all-none-container">
            <button type="button" class="select-button" (click)="selectAll()">
                <div class="button-content">
                    <svg class="icons-select select-all">
                        <use xlink:href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use>
                    </svg>
                    <span runat="server" id="" cvLocalizedText langSection="Gamification_Admin"
                        langKey="Select_All">Select All</span>
                </div>
            </button>
             <button type="button" class="select-button" (click)="selectNone()">
                <div class="button-content">
                    <svg class="icons-select select-none">
                        <use xlink:href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                    </svg>
                    <span runat="server" id="" cvLocalizedText langSection="Gamification_Admin"
                        langKey="Select_None">Select None</span>
                </div>    
            </button>
        </div>
        <div class="p-2" *ngIf="search || bulkOperations">
            <div class="search-box live-search" *ngIf="search">
                <input type="search" class="form-control" cvLocalizedPlaceholder langSection="Common" langKey="Search" 
                       [(ngModel)]="filterText" onkeydown="event.stopPropagation()" maxlength="50"/>
                <span class="clear-input" [hidden]="!filterText" (click)="filterText = ''"></span>
            </div>
        </div>
        <cdk-virtual-scroll-viewport [itemSize]="36" [minBufferPx]="minBufferPx" [maxBufferPx]="maxBufferPx" style="height: 176px;">
            <div *ngIf="dropdownLabel && dropdownLabel !== ''" class="ml-3 mb-1 dropdownLabel">{{dropdownLabel}}</div>
            <mat-checkbox class="ml-3" *ngIf="bulkOperations && filterText === ''" (click)="selectAll()" [indeterminate]="checkIndeterminate()" [checked]="checkChecked()"><span cvLocalizedText langSection="Common" langKey="All">All</span></mat-checkbox>
            <mat-checkbox class="ml-3" *ngIf="bulkOperations && filterText !== ''" (click)="selectSearch()" [indeterminate]="value.length > 0"><span cvLocalizedText langSection="Common" langKey="All">All</span></mat-checkbox>
            <mat-option *cdkVirtualFor="let option of options | filterText: filterText : label" 
            [ngClass]="{'groups-max-width': groupNameExist}"
            [value]="option[primaryKey]" 
            (onSelectionChange)="onMatSelectChange($event)" 
            [ngbTooltip]="groupNameExist ? groupInfo : ''"
            placement="bottom"
            tooltipClass="group-tooltip"
            container="body"
            #groupTooltip="ngbTooltip"
            triggers="hover">
                {{ option[label] }}
                <ng-template #groupInfo>
                        <span *ngIf="team.get(option.Group2ID) !== '' || option.Group2ID !== 0" class="label-text">{{team.get(option.Group2ID)}}</span>  
                        <span *ngIf="team.get(option.Group2ID) === '' || option.Group2ID === 0" class="label-text" cvLocalizedText langSection="Module" langKey="Team_Not_Available">Team NOT AVAILABLE</span> 
                        <br/>
                        <span *ngIf="option[email] !== ''">{{option[email]}}</span>
                        <span *ngIf="option[email] === '' || option[email] === null" cvLocalizedText langSection="Module" langKey="Email_Not_Available">Email NOT AVAILABLE</span>
                </ng-template>
            </mat-option>
        </cdk-virtual-scroll-viewport>
    </mat-select>
</mat-form-field>

